// extracted by mini-css-extract-plugin
export default {"container":"ingredient-details_container__WcIjY","image":"ingredient-details_image__C3eCe","nutrition":"ingredient-details_nutrition__ptDyc"};